import { Grid, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { useCallback, useEffect, useState } from 'react';
import { Version } from '@helpers/types';
import { useHttp } from '@hooks/use-http.ts';

interface IVersionSelectorProps {
  value: Array<Version>;
  station: string;
  country: string;
  onChange: (v: Array<Version>) => void;
}

const VersionSelector = (props: IVersionSelectorProps) => {
  const http = useHttp();
  const [versions, setVersions] = useState<Array<Version>>([]);
  const onChangeVersion = useCallback(
    (event: SelectChangeEvent<Version[]>) =>
      props.onChange(event.target.value as Version[]),
    [props],
  );

  useEffect(() => {
    http.lastmile.getVersions(props.country, props.station, false)
      .then((versions) => setVersions(versions))
      .catch((err) => console.log(err));
  }, [props.station, props.country, http]);

  return (
    <Grid size={{ xs: 12 }}>
      <Select
        fullWidth
        size="small"
        multiple={true}
        value={props.value}
        onChange={onChangeVersion}
        // @ts-ignore
        options={versions}
      >
        {versions.map((v) => (
          // @ts-ignore
          <MenuItem key={v._id} value={v}>
            {v.version}
          </MenuItem>
        ))}
      </Select>
    </Grid>
  );
};
export default VersionSelector;